<template>
  <form-section :headline="$t('form.goodwill.legend')" id="goodwill" v-if="isDistributor">
    <text-field
      id="goodwill_percent"
      :label="$t('form.goodwill.goodwill_percent.label')"
      :placeholder="$t('form.goodwill.goodwill_percent.placeholder')"
      v-model="goodwillPercent"
      isRequired
      appendText="%"
    />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import TextField from "@/shared/components/Textfield.vue";
export default {
  components: {
    FormSection,
    TextField
  },
  data() {
    return {
      goodwillPercent: ""
    };
  },
  computed: {
    isDistributor() {
      return this.$store.getters.isDistributorType;
    }
  },
  watch: {
    goodwillPercent: {
      handler() {
        this.$store.commit("updateGoodwillPercent", this.goodwillPercent);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/GoodwillInput.vue